import { render, staticRenderFns } from "./purchase_list.vue?vue&type=template&id=e5ca5222&scoped=true"
import script from "./purchase_list.vue?vue&type=script&lang=js"
export * from "./purchase_list.vue?vue&type=script&lang=js"
import style1 from "../../../assets/styles/management.scss?vue&type=style&index=1&id=e5ca5222&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ca5222",
  null
  
)

export default component.exports